const FILTERS = {
    "security-certification": {
        hitachi_product: {
            title: 'Product',
            icon: 'server.png'
        },
        certification_type: {
            title: 'Certification Type',
            icon: 'os.png'
        }
    }
}
export default FILTERS;